// extracted by mini-css-extract-plugin
export var commPress = "ArticlesPresseParAnnee-module--commPress--d0731";
export var container = "ArticlesPresseParAnnee-module--container--e7c98";